import { CarouselListService } from "./ListService";
import { Slider } from "./slider";


export const CarouselConfig = (function ( $ ) {

	var config = {
		delay:      300,
		slideTime:  12000,
		slideSpeed: 1200,
		baseUrl:    ""
	};

	var mySlider;

	return {
		init: function ( options ) {
			config.baseUrl = options.baseUrl;
			config.target = options.target;
			config.isDebugEnabled = options.isDebugEnabled || false;

            $.when(CarouselListService.getLists(options.baseUrl)).then(function(lists){
                config.lists = lists;
                if(lists.length > 0) {
                    mySlider = new Slider( config );
                    lists.forEach(function(list, i){
                        if( i === 0 ) {
                            mySlider.setDefaultResourceList( list.id, list.listItems );
                        }
                        else {
                            mySlider.setResourceList( list.id, list.listItems );
                        }
                    });
				}

            });

		},
		destroy: () => {
			mySlider?.destroy();
		}
	};
})( $ );

